function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#828282"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4991 8.64222H11.6025L13.5813 6.60556C11.6097 4.65556 8.41745 4.58333 6.44579 6.53333C4.47412 8.49056 4.47412 11.6467 6.44579 13.6039C8.41745 15.5611 11.6097 15.5611 13.5813 13.6039C14.5636 12.6361 15.0547 11.5022 15.0547 10.0722H16.4991C16.4991 11.5022 15.8636 13.3583 14.5925 14.615C12.0575 17.1283 7.94079 17.1283 5.40579 14.615C2.87801 12.1089 2.85634 8.03556 5.39134 5.52944C7.92634 3.02333 11.9925 3.02333 14.5275 5.52944L16.4991 3.5V8.64222ZM10.3602 7.11111V10.1806L12.888 11.6828L12.368 12.5567L9.2769 10.7222V7.11111H10.3602Z",
  fill: "white"
});

var SvgIconRescheduled = function SvgIconRescheduled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRescheduled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-rescheduled.2bc309d5.svg";
export { ForwardRef as ReactComponent };